<template>
  <div>
    <transition name="mode-fade" mode="out-in">
      <CustomCard
        v-if="step == 0"
        key="age"
        type="select"
        :lastStep="lastStep"
        :label="ageLabel"
        :placeHolder="agePlaceHolder"
        :errMsg="ageErrMsg"
        :value="localValue"
        :options="ageOptions"
        :required="true"
        @submit="submitAge($event)"
      />
      <CustomCard
        v-if="step == 1"
        key="ageConfirm"
        type="select"
        :lastStep="lastStep"
        :label="confirmLabelEdited"
        :placeHolder="confirmPlaceHolder"
        :errMsg="confirmErrMsg"
        :value="ageConfirm"
        :options="confirmOptions"
        :required="true"
        @submit="submitConfirm($event)"
      />
      <CustomCard
        v-if="step == 2"
        key="secondAge"
        type="select"
        :lastStep="lastStep"
        :label="secondAgeLabel"
        :placeHolder="agePlaceHolder"
        :errMsg="ageErrMsg"
        :value="sAge"
        :options="ageOptions"
        :required="true"
        @submit="submitSecondAge($event)"
      />
    </transition>
  </div>
</template>

<script>
import CustomCard from "./CustomCard.vue";

export default {
  name: "AgeComponent",
  components: { 
    CustomCard 
  },
  props: [
    "value", 
    "lastStep",
    "ageLabel",
    "confirmLabel",
    "secondAgeLabel",
    "ageErrMsg",
    "confirmErrMsg",
    "agePlaceHolder",
    "confirmPlaceHolder",
    "minAge",
    "state"
  ],
  watch: { 
    value: function(newVal) {
      this.localValue = newVal
    }
  },
  data() {
    return {
      step: 0,
      localValue: this.value,
      ageConfirm: "",
      sAge: "",
      confirmOptions: {
        yes: "Yes",
        no: "No"
      }
    }
  },
  methods: {
    submitAge: function(age) {
      if (age == this.minimumAge - 1) {
        this.localValue = age;
        this.step++;
      } else {
        this.$emit("submit", age);
      }
      
    },
    submitConfirm: function(confirmAnswer) {
      this.ageConfirm = confirmAnswer;
      if (confirmAnswer == 'yes') {
        this.step++;
      } else {
        this.$emit("submit", this.localValue);
      }
    },
    submitSecondAge: function(secondAge) {
      this.$emit("submit", secondAge);
    }
  },
  computed: {
    ageOptions: function() {
      let options = {}
      if (this.step == 0) {
        options[ this.minimumAge - 1] = "Under "+this.minAge[this.state]
      }
      for (let index = this.minimumAge; index < 91; index++) {
        options[index] = String(index);
      }
      options[90] = "90+";
      return options;
    },
    confirmLabelEdited: function() {
      var reg = new RegExp("xx", "g");
      return this.confirmLabel.replace(reg, this.minAge[this.state])
    },
    minimumAge: function() {
      let _minAge = 62; //default minimum age
      if (this.state && this.state in this.minAge) {
        _minAge = Number(this.minAge[this.state]);
      }
      return _minAge;
    }
  }

}
</script>